import { AxiosRequestConfig } from 'axios'
import { Provider } from 'containers/Dashboard/types'

export const QUERY_KEYS = {
  STATES: 'states',
  PATIENT: 'patient',
  PATIENTS: 'patients',
  TIMELIME: 'timeline',
  ANALYTICS: 'analytics',
  PROVIDERS: 'providers',
  INACTIVE_PATIENTS: 'inactive-patients',
  APPOINTMENT_TYPES: 'appointment-types',
  ELIGIBLE_INSURANCES: 'eligible-insurances',
}

export type UpdatePatientProviderParams = {
  patientId: string
  type: 'medical-provider' | 'dietician'
  provider: Provider | null
}

export function getAxiosConfig(accessToken: string): AxiosRequestConfig {
  return {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }
}

// From axios 0.27, AxiosRequestConfig is no longer assignable to fetch's
// RequestInit, so fetch() call sites need their own config with the same headers.
export function getFetchConfig(accessToken: string): RequestInit {
  return {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }
}
